module.exports = __webpack_public_path__ + "img/promate-software-logo-sm.fc93eb47.png";